<template>
  <div>
    <el-row>
      <el-col :span="5">
        <div style="margin-right:15px;">
          <el-card>
            <b-button class="mb-3" @click="createPrj" block variant="danger">{{
              $l('btn_create_project') || '创建项目'
            }}</b-button>
            <b-list-group>
              <b-list-group-item
                href="#"
                :active="leftNavActive.isAll"
                @click="clickGroup('all')"
                class="d-flex justify-content-between align-items-center left-group-item"
              >
                <div>
                  <i class="fa fa-reorder mr-1"></i>
                  {{ $l('filter_0') || '我的全部项目' }}
                </div>
                <b-badge variant="secondary">{{ prjTypeNumber.all }}</b-badge>
              </b-list-group-item>
              <b-list-group-item
                href="#"
                :active="leftNavActive.isOngoing"
                @click="clickGroup('ongoing')"
                class="d-flex justify-content-between align-items-center left-group-item"
              >
                <div>
                  <i class="fa fa-random mr-1"></i>
                  {{ $l('filter_1') || '进行中项目' }}
                </div>
                <b-badge variant="success">{{ prjTypeNumber.ongoing }}</b-badge>
              </b-list-group-item>
              <b-list-group-item
                href="#"
                :active="leftNavActive.isDeadLine"
                @click="clickGroup('deadLine')"
                class="d-flex justify-content-between align-items-center left-group-item"
              >
                <div>
                  <i class="fa fa-bell-o mr-1"></i>
                  {{ $l('filter_8') || '最后期限项目' }}
                </div>
                <b-badge variant="danger">{{ prjTypeNumber.deadLine }}</b-badge>
              </b-list-group-item>
              <b-list-group-item
                href="#"
                :active="leftNavActive.isSevenDays"
                @click="clickGroup('sevenDays')"
                class="d-flex justify-content-between align-items-center left-group-item"
              >
                <div>
                  <i class="fa fa-hourglass-o mr-1"></i>
                  {{ $l('filter_2') || '7 天到期项目' }}
                </div>
                <b-badge variant="warning">{{
                  prjTypeNumber.sevenDays
                }}</b-badge>
              </b-list-group-item>
              <b-list-group-item
                href="#"
                :active="leftNavActive.isThirtyDays"
                @click="clickGroup('thirtyDays')"
                class="d-flex justify-content-between align-items-center left-group-item"
              >
                <div>
                  <i class="fa fa-calendar-minus-o mr-1"></i>
                  {{ $l('filter_3') || '30 天到期项目' }}
                </div>
                <b-badge variant="info">{{ prjTypeNumber.thirtyDays }}</b-badge>
              </b-list-group-item>
              <b-list-group-item
                href="#"
                :active="leftNavActive.isOverdue"
                @click="clickGroup('overdue')"
                class="d-flex justify-content-between align-items-center left-group-item"
              >
                <div>
                  <i class="fa fa-share-square-o mr-1"></i>
                  {{ $l('filter_4') || '已超期项目' }}
                </div>
                <b-badge variant="warning">{{ prjTypeNumber.overdue }}</b-badge>
              </b-list-group-item>
              <b-list-group-item
                href="#"
                :active="leftNavActive.isFinish"
                @click="clickGroup('finish')"
                class="d-flex justify-content-between align-items-center left-group-item"
              >
                <div>
                  <i class="fa fa-flag-o mr-1"></i>
                  {{ $l('filter_5') || '已完成项目' }}
                </div>
                <b-badge variant="secondary">{{
                  prjTypeNumber.finish
                }}</b-badge>
              </b-list-group-item>
              <b-list-group-item
                href="#"
                :active="leftNavActive.isCancel"
                @click="clickGroup('cancel')"
                class="d-flex justify-content-between align-items-center left-group-item"
              >
                <div>
                  <i class="fa fa-trash-o mr-1"></i>
                  {{ $l('filter_6') || '已终止项目' }}
                </div>
                <b-badge variant="danger">{{ prjTypeNumber.cancel }}</b-badge>
              </b-list-group-item>
              <b-list-group-item
                href="#"
                :active="leftNavActive.isDraft"
                @click="clickGroup('draft')"
                class="d-flex justify-content-between align-items-center left-group-item"
              >
                <div>
                  <i class="fa fa-edit mr-1"></i>
                  {{ $l('filter_7') || '草稿项目' }}
                </div>
                <b-badge variant="secondary">{{ prjTypeNumber.draft }}</b-badge>
              </b-list-group-item>
            </b-list-group>
          </el-card>
        </div>
      </el-col>
      <el-col :span="19">
        <el-card>
          <page-main
            ref="main"
            :table-data="table"
            :loading="loading"
            @submit="reload"
            @fromLoad="fromLoad"
            :tablePage="page"
          >
            <page-header
              @reset="reset"
              slot="header"
              @submit="loadData"
              @searchFile="searchFile"
              ref="header"
            >
            </page-header>
            <pagination
              :current-page="page.curPage"
              :page-size="page.pageSize"
              :page-total="page.pageTotal"
              size="small"
              align="right"
              slot="pager"
              @change="handlePaginationChange"
            />
          </page-main>
        </el-card>
      </el-col>
      <el-dialog
        :title="$l('table_label_search_Document') || '文档搜索'"
        width="1200px"
        v-if="searchFileDialogVisible"
        :close-on-click-modal="false"
        show-close
        :visible.sync="searchFileDialogVisible"
        top="10vh"
        destroy-on-close
        append-to-body
      >
        <SearchFileTable :searchFileForm="form" />
      </el-dialog>
    </el-row>
    <add-project ref="addProject" />
  </div>
</template>

<script>
import AddProject from '@/views/digital/projectManager/info/components/add'
import PageMain from '../table/main.vue'
import PageHeader from '../table/header.vue'
import SearchFileTable from '../searchFileTable'

const initPage = {
  curPage: 1,
  pageSize: 5,
  pageTotal: 0,
}

export default {
  props: {},
  components: {
    AddProject,
    PageMain,
    PageHeader,
    SearchFileTable,
  },
  data() {
    return {
      leftNavActive: {
        isOngoing: false,
        isDeadLine: false,
        isSevenDays: false,
        isThirtyDays: false,
        isOverdue: false,
        isFinish: false,
        isCancel: false,
        isDraft: false,
        isAll: false,
      },
      table: [],
      loading: false,
      page: {
        ...initPage,
      },
      searchFileDialogVisible: false,
      prjTypeNumber: {
        all: 0,
        ongoing: 0,
        sevenDays: 0,
        thirtyDays: 0,
        overdue: 0,
        finish: 0,
        cancel: 0,
        draft: 0,
        deadLine: 0,
        prjCategoryList: [],
      },
      form: {
        prjType: '',
      },
    }
  },
  created() {
    this.selPrjTypeNumber()
    this.init()
  },
  methods: {
    init() {
      this.setNavActive('all')
      this.loadData(this.form)
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.loadData(this.form)
      })
    },
    // 重载表格数据
    reload() {
      this.$refs.header.query()
    },
    // 加载表格数据
    loadData(form) {
      this.loading = true
      this.$api
        .dashBoardListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 仪表板项目类型数量查询
    selPrjTypeNumber() {
      this.$api
        .dashBoardGetPrjTypeNumber()
        .then((res) => {
          this.prjTypeNumber = res.body
        })
        .catch(() => {})
    },
    reset() {
      this.resetParam()
    },
    resetParam() {
      this.page = {
        ...initPage,
      }
    },
    // 加载表单
    fromLoad({ ref, val = '' }) {
      if (ref === 'edit') {
        this.$router.push({
          name: 'projectManagement-projectInfo-edit',
          params: {
            pageType: ref,
            prjCode: val,
          },
        })
      } else {
        this.$router.push({
          name: 'projectManagement-projectInfo-detail',
          params: {
            pageType: ref,
            prjCode: val,
          },
        })
      }
    },
    //创建项目
    createPrj() {
      let val = {
        formTitle: this.$l('INDEX.label_title_add_project') || '新增项目',
      }
      this.$refs.addProject.fromLoad('add', val)
      return
    },
    // 左侧列表单击
    clickGroup(type) {
      this.resetParam()
      this.setNavActive(type)
      this.loadData(this.form)
    },
    setNavActive(type) {
      if (type === 'ongoing') {
        this.form.prjType = 'ongoing'
        this.leftNavActive.isOngoing = true
        this.leftNavActive.isDeadLine = false
        this.leftNavActive.isSevenDays = false
        this.leftNavActive.isThirtyDays = false
        this.leftNavActive.isOverdue = false
        this.leftNavActive.isFinish = false
        this.leftNavActive.isCancel = false
        this.leftNavActive.isDraft = false
        this.leftNavActive.isAll = false
      } else if (type === 'deadLine') {
        this.form.prjType = 'deadLine'
        this.leftNavActive.isOngoing = false
        this.leftNavActive.isDeadLine = true
        this.leftNavActive.isSevenDays = false
        this.leftNavActive.isThirtyDays = false
        this.leftNavActive.isOverdue = false
        this.leftNavActive.isFinish = false
        this.leftNavActive.isCancel = false
        this.leftNavActive.isDraft = false
        this.leftNavActive.isAll = false
      } else if (type === 'sevenDays') {
        this.form.prjType = 'sevenDays'
        this.leftNavActive.isOngoing = false
        this.leftNavActive.isDeadLine = false
        this.leftNavActive.isSevenDays = true
        this.leftNavActive.isThirtyDays = false
        this.leftNavActive.isOverdue = false
        this.leftNavActive.isFinish = false
        this.leftNavActive.isCancel = false
        this.leftNavActive.isDraft = false
        this.leftNavActive.isAll = false
      } else if (type === 'thirtyDays') {
        this.form.prjType = 'thirtyDays'
        this.leftNavActive.isOngoing = false
        this.leftNavActive.isDeadLine = false
        this.leftNavActive.isSevenDays = false
        this.leftNavActive.isThirtyDays = true
        this.leftNavActive.isOverdue = false
        this.leftNavActive.isFinish = false
        this.leftNavActive.isCancel = false
        this.leftNavActive.isDraft = false
        this.leftNavActive.isAll = false
      } else if (type === 'overdue') {
        this.form.prjType = 'overdue'
        this.leftNavActive.isOngoing = false
        this.leftNavActive.isDeadLine = false
        this.leftNavActive.isSevenDays = false
        this.leftNavActive.isThirtyDays = false
        this.leftNavActive.isOverdue = true
        this.leftNavActive.isFinish = false
        this.leftNavActive.isCancel = false
        this.leftNavActive.isDraft = false
        this.leftNavActive.isAll = false
      } else if (type === 'finish') {
        this.form.prjType = 'finish'
        this.leftNavActive.isOngoing = false
        this.leftNavActive.isDeadLine = false
        this.leftNavActive.isSevenDays = false
        this.leftNavActive.isThirtyDays = false
        this.leftNavActive.isOverdue = false
        this.leftNavActive.isFinish = true
        this.leftNavActive.isCancel = false
        this.leftNavActive.isDraft = false
        this.leftNavActive.isAll = false
      } else if (type === 'cancel') {
        this.form.prjType = 'cancel'
        this.leftNavActive.isOngoing = false
        this.leftNavActive.isDeadLine = false
        this.leftNavActive.isSevenDays = false
        this.leftNavActive.isThirtyDays = false
        this.leftNavActive.isOverdue = false
        this.leftNavActive.isFinish = false
        this.leftNavActive.isCancel = true
        this.leftNavActive.isDraft = false
        this.leftNavActive.isAll = false
      } else if (type === 'draft') {
        this.form.prjType = 'draft'
        this.leftNavActive.isOngoing = false
        this.leftNavActive.isDeadLine = false
        this.leftNavActive.isSevenDays = false
        this.leftNavActive.isThirtyDays = false
        this.leftNavActive.isOverdue = false
        this.leftNavActive.isFinish = false
        this.leftNavActive.isCancel = false
        this.leftNavActive.isDraft = true
        this.leftNavActive.isAll = false
      } else if (type === 'all') {
        this.form.prjType = 'all'
        this.leftNavActive.isOngoing = false
        this.leftNavActive.isDeadLine = false
        this.leftNavActive.isSevenDays = false
        this.leftNavActive.isThirtyDays = false
        this.leftNavActive.isOverdue = false
        this.leftNavActive.isFinish = false
        this.leftNavActive.isCancel = false
        this.leftNavActive.isDraft = false
        this.leftNavActive.isAll = true
      }
    },
    searchFile() {
      this.searchFileDialogVisible = true
    },
  },
}
</script>
<style lang="scss" scoped>
.hidden-header {
  display: none;
}
.left-dropdown-item {
  font-size: 15px;
  font-weight: 400;
}
.left-group-item {
  border: none;
  padding-left: 5px;
  padding-right: 5px;
  height: 52px;
  font-size: 15px;
  color: #6c757d;
}

.table-text {
  color: #6c757d;
  font-size: 14.4px;
}

.text-uppercase {
  color: #6c757d;
  font-size: 12px;
}
.font-12 {
  font-size: 12px;
}
.active {
  font-size: 16px;
  font-weight: 500;
  background-color: #fff;
}
</style>
